import {
  applyMiddleware,
  compose,
  createStore
} from "redux";
import thunk from 'redux-thunk';
import rootReducer from "./reducer";

var reduxPlugin =
  window.__REDUX_DEVTOOLS_EXTENSION__ != null ?
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
  window.__REDUX_DEVTOOLS_EXTENSION__() :
  null;

var plugins = [applyMiddleware(thunk)];
if (reduxPlugin != null) {
  plugins.push(reduxPlugin);
}

export default createStore(rootReducer, {}, compose.apply(null, plugins));